import {
  ComponentsService,
  ManifestComponentExtensionType,
} from '@wix/editor-platform-manifest-services';

type PublicKeys<T> = {
  [K in keyof T]: T[K] extends (...args: any[]) => any
    ? K
    : T[K] extends object
    ? K extends string
      ? K
      : never
    : K;
}[keyof T];

type PublicAPI<T> = Pick<T, PublicKeys<T>>;

export const mockPublicManifestAPI = {
  behaviors: {
    is: {
      removable: () => false,
      selectable: () => false,
    },
  },
  layout: {
    get: {
      resizeDirection: () => null,
      contentResizeDirection: () => null,
      contentFill: () => null,
    },
    is: {
      stretchingDisabled: () => false,
      positioningDisabled: () => false,
      rotationDisabled: () => false,
    },
  },
  get: {
    getAll: () => ({}),
    displayName: () => null,
    selector: () => null,
    style: () => null,
    presets: () => null,
    displayGroups: () => null,
    data: () => null,
    interactions: () => null,
    getMediaData: () => null,
    help: () => null,
    archetype: () => null,
    containerData: () => null,
    editActions: () => null,
    customActions: () => null,
    defaultData: () => null,
    defaultStyle: () => null,
  },

  states: {
    getStateDefinitions: () => ({}),
    getState: () => null,
    setState: () => {},
    activateVisibilityState: () => {},
  },

  onManifestChange: () => () => {},

  isBoxLike: () => false,
  isBuilderComponentType: () => false,
};

export const mockPublicHierarchyAPI = {
  getChildren: () => [],
  getChildrenEditorPointers: () => [],
  getAncestors: () => [],
  getActionableElements: () => null,
};

export const componentsServicePact: PublicAPI<ComponentsService> = {
  getPanel: () => null,
  getContext: () => ({} as any),
  getChildrenEditorPointers: () => [],
  loadAppManifestAndPanels: () => Promise.resolve(),
  getElementsData: () => ({
    showElementsPanel: false,
    manifest: undefined,
    metadata: null,
    extensionType: ManifestComponentExtensionType.UNKNOWN,
  }),
  editActions: {
    resolveDataItems: () => [],
    resolvePresetItems: () => ({}),
    applyDisplayFilters: () => ({}),
    hasTemplates: () => false,
  },
  behaviors: {
    getValue: () => null,
  },
  layout: {
    getValue: () => null,
  },
  states: {
    getStateDefinitions: () => ({}),
    getState: () => null,
    setState: () => {},
    reconcileStatesOnComponentSelection: () => {},
    activateVisibilityState: () => {},
  },
  get: {
    getAll: () => ({}),
    customActions: () => ({}),
    editActions: () => ({}),
    displayName: () => null,
    selector: () => null,
    archetype: () => null,
    presets: () => ({}),
    displayGroups: () => ({}),
    interactions: () => null,
    data: () => ({}),
    help: () => null,
    imageData: () => null,
    containerData: () => null,
    menuData: () => null,
    mediaData: () => null,
    style: () => ({
      cssProperties: {},
      cssCustomProperties: {},
    }),
    defaultDataValue: () => null,
    defaultCustomStyleValue: () => null,
    defaultStyleValue: () => null,
  },
  utilities: {
    isBuilderComponentType: () => false,
  },
  isBoxLike: () => false,
  getChildren: () => [],
  getAncestors: () => [],
  getPublicManifestAPI: () => mockPublicManifestAPI,
  getPublicHierarchyAPI: () => mockPublicHierarchyAPI,
  getActionableElements: () => null,
  [Symbol.for('pactBuilderServices')]: true,
};

export const getComponentsServicePact = () =>
  componentsServicePact as ComponentsService;
